<script setup lang="ts">
import { computed, reactive } from "vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const thisYear = computed(() => new Date().getFullYear())
</script>
<template>
  <div
    class="sticky bottom-0 flex justify-between items-center w-full max-w-5xl p-4 bg-sky-50 dark:bg-gray-800 rounded-none lg:rounded-t-lg text-gray-700 dark:text-gray-300 border border-b-0 dark:border-gray-700 border-opacity-50 transition-colors duration-500 transform-gpu shadow-lg">
    <p class="text-sm font-medium" title="Basic and Limited of SSO Management">
      {{ t('app long name') }} v1.0
    </p>
    <p class="text-sm font-medium flex gap-x-1">
      {{ thisYear }} &#169; PTPN IV
    </p>
  </div>
</template>
